import React from "react";
import HomePage from "./pages/homepage/HomePage";

function App() {
  return <HomePage />;
}

export default App;
